angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/projects/projects.html',
    '<update-title title="PEforHire.com"></update-title>\n' +
    '<!-- Projects -->\n' +
    '<section class="content dashboard">\n' +
    '    <div class="container">\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12" ng-show="first">\n' +
    '                <!-- Welcome message -->\n' +
    '                <div id="welcome" class="dashboard-box">\n' +
    '                    <a class="pull-right close" onclick="document.getElementById(\'welcome\').className=\'hidden\';"></a>\n' +
    '                    <h2 class="welcome">Welcome!\n' +
    '                    </h2>\n' +
    '                    <div class="row">\n' +
    '                        <div class="col-sm-8 welcome">\n' +
    '                            <p>Thank you for posting your project, we\'re thrilled to have you as part of our community!\n' +
    '                            </p>\n' +
    '                            <p>Please take a minute to\n' +
    '                                <a href="" ui-sref="edit-profile">complete your Profile</a>.</p>\n' +
    '                        </div>\n' +
    '                        <div class="col-sm-4 col-md-3 col-md-offset-1">\n' +
    '                            <a class="btn btn-primary btn-lg btn-welcome" href="" ui-sref="edit-profile">Complete\n' +
    '                                Profile</a>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-12">\n' +
    '                <ul class="hidden-xs list-inline pull-right mt60">\n' +
    '                    <li class="form-group text-muted">\n' +
    '                        Display:\n' +
    '                    </li>\n' +
    '                    <li class="form-group" ng-repeat="value in paging.values">\n' +
    '                        <input id="list-{{value}}" class="form-control" name="pageMode" ng-model="paging.mode"\n' +
    '                            ng-value="value" type="radio">\n' +
    '                        <label for="list-{{value}}">\n' +
    '                            <span></span>{{paging.display[$index]}}\n' +
    '                        </label>\n' +
    '                    </li>\n' +
    '                </ul>\n' +
    '                <h2>My Projects</h2>\n' +
    '                <!-- Start -->\n' +
    '                <table class="table table-striped">\n' +
    '                    <thead>\n' +
    '                        <tr>\n' +
    '                            <th class="hidden-xs">\n' +
    '                                <a href="">Posted</a>\n' +
    '                            </th>\n' +
    '                            <th>\n' +
    '                                <a href="#">Title</a>\n' +
    '                            </th>\n' +
    '                            <th class="hidden-xs hidden-sm projects-status-column">\n' +
    '                                <a href="">Status</a>\n' +
    '                            </th>\n' +
    '                            <th class="hidden-xs eng-type-column">\n' +
    '                                <a href="">Engineer Type</a>\n' +
    '                            </th>\n' +
    '                            <th class="hidden-xs">\n' +
    '                                <a href="">State</a>\n' +
    '                            </th>\n' +
    '                            <th>\n' +
    '                                <a href="">Proposals</a>\n' +
    '                            </th>\n' +
    '                            <th>\n' +
    '                                <a href="">Questions</a>\n' +
    '                            </th>\n' +
    '                            <th>\n' +
    '                                <a href="">Messages</a>\n' +
    '                            </th>\n' +
    '\n' +
    '                            <th class="hidden-xs hidden-sm">\n' +
    '                                <a href="">Share</a>\n' +
    '                            </th>\n' +
    '                            <th>\n' +
    '                                <a href="">View</a>\n' +
    '                            </th>\n' +
    '                            <th class="hidden-xs projectsView_actionsColumn">\n' +
    '                                <a href="">Actions</a>\n' +
    '                            </th>\n' +
    '                        </tr>\n' +
    '                    </thead>\n' +
    '                    <tbody>\n' +
    '                        <tr ng-repeat="project in projects">\n' +
    '                            <td class="hidden-xs">{{project.CreatedDate|standardMonthDayYear}}</td>\n' +
    '                            <td>\n' +
    '                                <a class="title"\n' +
    '                                    ui-sref="project({uid: project.UID})">{{project.Title | characters:40}}</a>\n' +
    '                            </td>\n' +
    '                            <td ng-if="isFull(project)" class="hidden-xs hidden-sm">\n' +
    '                                <i class="fa fa-circle fa-fw"\n' +
    '                                    ng-style="{\'color\': projectStatesDict[\'full\'].color}"></i>{{projectStatesDict[\'full\'].label}}\n' +
    '                            </td>\n' +
    '                            <td ng-if="!isFull(project)" class="hidden-xs hidden-sm">\n' +
    '                                <i ng-if="!isFull(project)" class="fa fa-circle fa-fw"\n' +
    '                                    ng-style="{\'color\': projectStatesDict[project.Status].color}"></i>{{projectStatesDict[project.Status].label}}\n' +
    '                            </td>\n' +
    '                            <td class="hidden-xs">{{getLicenseFromId(project.LicenseId).Label}}</td>\n' +
    '                            <td class="hidden-xs text-center">{{project.StateLicense}}</td>\n' +
    '                            <td>\n' +
    '                                <div ui-sref="project({uid: project.UID})"\n' +
    '                                    ng-class="{\'unread-notification\': project.UnreadProposals}">\n' +
    '                                    {{project.ProposalsCount}}</div>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                                <div ui-sref="project({uid: project.UID, questions:true})"\n' +
    '                                    ng-class="{\'unread-notification\': project.QuestionCount>0 && project.QuestionCount>project.QuestionAnswered}"\n' +
    '                                    ui-sref="project">{{project.QuestionCount}}</div>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                                <div ui-sref="project({uid: project.UID})"\n' +
    '                                    ng-class="{\'unread-notification\': project.UnreadMessages}">\n' +
    '                                    {{project.MessagesReceived}}</div>\n' +
    '                            </td>\n' +
    '                            <td class="hidden-xs hidden-sm text-center">\n' +
    '                                <a href=""\n' +
    '                                    ng-click="openCopyProjectUrl(\'project\', {uid: project.UID, projectTitle:generateSeoUrlForProject(project)})">URL</a>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                                <a ui-sref="project({uid: project.UID, projectTitle:generateSeoUrlForProject(project)})"\n' +
    '                                    class="btn btn-primary btn-xs"\n' +
    '                                    ng-class="{\'btn-off\': project.Status == \'closed\'}">View</a>\n' +
    '                            </td>\n' +
    '                            <td class="projectsView_actionsColumn">\n' +
    '                                <a ng-if="existsStatus(project.Status)" ui-sref="projects({uid: project.UID})"\n' +
    '                                    class="btn btn-primary btn-xs">{{getStatusAction(project.Status)}}</a>\n' +
    '                            </td>\n' +
    '                        </tr>\n' +
    '                    </tbody>\n' +
    '                </table>\n' +
    '                <!-- Pagination -->\n' +
    '                <div class="text-left" ng-show="paging.mode != paging.values[paging.values.length-1]">\n' +
    '                    <div paging page="paging.current" ng-model="projectsAll" page-size="paging.mode"\n' +
    '                        total="paging.total" paging-action="goToPage(page)" prev="goToPage(paging.current-1)"\n' +
    '                        next="goToPage(paging.current+1)"></div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-request-invoice.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Request Invoice Sent!</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <div ng-repeat="message in requestInvoiceMessage">\n' +
    '            <p>{{message}}</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <div class="col-md-12">\n' +
    '            <button type="button" ng-click="$close()" class="btn btn-default">Close</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-review-invoice.html">\n' +
    '    <form name="form.reviewInvoiceForm" novalidate autocomplete="off" ng-submit="approveInvoiceConfirmation()">\n' +
    '        <div class="modal-header">\n' +
    '            <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '                <i class="fa fa-times"></i>\n' +
    '            </a>\n' +
    '            <h4 class="modal-title">Review Invoice</h4>\n' +
    '        </div>\n' +
    '        <div class="modal-header">\n' +
    '            <p><strong>From: </strong>{{from}}</p>\n' +
    '            <div class="send-invoice-confirmation-note">\n' +
    '                <label class="send-invoice-confirmation-note-text"><strong>Note: </strong>{{note}}</label>\n' +
    '            </div>\n' +
    '            <div ng-if="attachments.length" style="margin-bottom: 10px">\n' +
    '                <strong>Attachments:&nbsp;</strong>\n' +
    '                <div ng-repeat="att in attachments track by att.Id">\n' +
    '                    <a href="{{att.Key.Url}}" target="_blank" style="margin-left: 20px">{{att.Name}}</a>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <p><strong>Total*: </strong>${{total | currency:"":2}}</p>\n' +
    '        </div>\n' +
    '        <div class="modal-body">\n' +
    '            <div class="">\n' +
    '                <span class="pull-right">\n' +
    '                    <small>char. remaining:</small>\n' +
    '                    <strong>{{remainingCharacters}}</strong>\n' +
    '                </span>\n' +
    '            </div>\n' +
    '            <textarea ng-model="invoiceText" name="invoiceText" class="form-control"\n' +
    '            rows="4" placeholder="NOTE TO ENGINEER (REQUIRED IF REJECTING INVOICE)" ng-change="updateCharactersLeft()" maxlength="2000"></textarea>\n' +
    '            <div class="help-block" ng-class="{ \'errors\': form.invoiceForm.invoiceText.$touched && (form.invoiceForm.invoiceText.$invalid||invoiceText.length>maxInvoiceLength) }"\n' +
    '            ng-messages="form.invoiceForm.invoiceText.$error" ng-if="form.invoiceForm.invoiceText.$touched">\n' +
    '                <p ng-if="invoiceText.length>maxInvoiceLength">This field is too long.</p>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="modal-footer">\n' +
    '            <div class="form-group">\n' +
    '                <div class="col-md-12 text-left" ng-repeat="message in reviewInvoiceMessage">\n' +
    '                    <p>{{message}}</p>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '                <div class="col-md-12">\n' +
    '                    <button type="button" ng-click="rejectInvoiceConfirmation()" ng-disabled="invoiceText.length==0" class="btn btn-default">Reject</button>\n' +
    '                    <button type="submit" class="btn btn-primary">Approve</button>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </form>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-invoice-reject-confirmation.html">\n' +
    '    <div class="modal-body-mini-confirmation">\n' +
    '        <p>\n' +
    '           Are you sure you want to reject the invoice?\n' +
    '        </p>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <button ng-disabled="rejectingInvoice" type="button" ng-click="$close()" class="btn btn-default">No</button>\n' +
    '        <button ng-disabled="rejectingInvoice" ng-click="rejectInvoice()" class="btn btn-primary">Yes</button>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-invoice-approve-confirmation.html">\n' +
    '    <div class="modal-body-mini-confirmation">\n' +
    '        <p>\n' +
    '           Are you sure you want to approve the invoice?\n' +
    '        </p>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <button ng-disabled="approvingInvoice" type="button" ng-click="$close()" class="btn btn-default">No</button>\n' +
    '        <button ng-disabled="approvingInvoice" ng-click="approveInvoice()" class="btn btn-primary">Yes</button>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-invoice-approve.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Invoice Approved!</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body" ng-repeat="message in invoiceApprovedMessage">\n' +
    '        <div>\n' +
    '            <p>{{message}}</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <div class="col-md-12">\n' +
    '            <button type="button" ng-click="fundEscrowAfterApprovement()" class="btn btn-primary">Continue</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-verify-account.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">{{title}}</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <div ng-repeat="message in verifyEscrowAccountMessage">\n' +
    '            <p>\n' +
    '                {{message}}\n' +
    '            </p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <button ng-if="verificationStatus !== \'not_verified\'" type="button" ng-click="$close()" class="btn btn-default">Close</button>\n' +
    '        <button ng-if="verificationStatus == \'not_verified\'" ng-click="redirectToVerifyAccount()" class="btn btn-primary">Verify Account</button>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-invoice-rejected.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Invoice Rejected!</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <div ng-repeat="message in invoiceRejectedMessage">\n' +
    '            <p>{{message}}</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <div class="col-md-12">\n' +
    '            <button type="button" ng-click="$close()" class="btn btn-default">Close</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-request-revised-invoice-confirmation.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Request for Revised Invoice Sent!</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body" ng-repeat="message in requestRevisedInvoiceConfirmationMessage">\n' +
    '        <div>\n' +
    '            <p>{{message}}</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <div class="col-md-12">\n' +
    '            <button type="button" ng-click="$close()" class="btn btn-default">Close</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-wire-transfer-info.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Wire Transfer Information</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body" style="margin:0px 15px 0px 15px; padding:15px 0px 0px 0px;">\n' +
    '        <div ng-repeat="message in wireTransferStepsMessage">\n' +
    '            <p>{{message}}</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-body" style="margin-bottom: 0">\n' +
    '        <p><strong>Bank Name: </strong>{{bankName}}</p>\n' +
    '        <p><strong>Bank Address: </strong>{{bankAddress}}</p>\n' +
    '        <p><strong>Routing Number: </strong>{{routingNumber}}</p>\n' +
    '        <p><strong>Swift Code: </strong>{{swiftCode}}</p>\n' +
    '        <p><strong>Credit Account Name: </strong>{{creditAccountName}}</p>\n' +
    '        <p><strong>Credit Account Number: </strong>{{creditAccountNumber}}</p>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <div class="form-group">\n' +
    '            <div class="col-md-12 text-left" ng-repeat="message in confirmWireTransferMessage">\n' +
    '                <p>{{message}}</p>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-md-12">\n' +
    '                <button type="button" ng-click="$close()" class="btn btn-default">Close</button>\n' +
    '                <button type="button" ng-click="printDetails()" class="btn btn-default">Print Details</button>\n' +
    '                <button type="button" ng-click="openWireTransferPaymentConfirmationModal()" class="btn btn-primary">Confirm Payment</button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-wire-transfer-confirmation.html">\n' +
    '    <div class="modal-body-mini-confirmation">\n' +
    '        <p>\n' +
    '           Are you sure you want to confirm the payment?\n' +
    '        </p>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <button ng-disabled="confirmingPayment" type="button" ng-click="$close()" class="btn btn-default">No</button>\n' +
    '        <button ng-disabled="confirmingPayment" ng-click="confirmPayment()" class="btn btn-primary">Yes</button>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-payment-confirmed.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Payment Confirmed Successfully!</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <div ng-repeat="message in paymentConfirmationMessage">\n' +
    '            <p>{{message}}</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <div class="col-md-12">\n' +
    '            <button type="button" ng-click="$close()" class="btn btn-default">Close</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-payment-submitted.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Payment Submitted Successfully!</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <div ng-repeat="message in paymentSubmittedMessage">\n' +
    '            <p>{{message}}</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <div class="col-md-12">\n' +
    '            <button type="button" ng-click="$close()" class="btn btn-default">Close</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-release-of-funds.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a ng-disabled="releasingFunds" class="close" data-dismiss="modal" ng-click="close()" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Release Funds</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body row">\n' +
    '        <div class="col-xs-1">\n' +
    '            <input type="checkbox" ng-model="confirmed" id="agree-release-of-funds-id"/>\n' +
    '            <label for="agree-release-of-funds-id"><span></span></label>\n' +
    '        </div>\n' +
    '        <div ng-repeat="message in releaseOfFundsMessage">\n' +
    '            <p class="col-xs-11">{{message}}</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <div class="col-md-12">\n' +
    '            <button ng-disabled="!confirmed || releasingFunds" type="button" ng-click="releaseFunds()" class="btn btn-primary">Release Funds</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-funds-released.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Funds Released!</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <div ng-repeat="message in fundsReleasedMessage">\n' +
    '            <p>{{message}}</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <div>\n' +
    '            <button type="button" class="btn btn-primary" ng-click="redirectToSubmitReview()">Submit a Review</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>');
}]);
